import React from 'react'
import { Col, Row } from 'reactstrap'
import DropDown from './DropDown'

import { getHierarchyOptions, HierarchyCoords, Option, FormItem, getAssignments, Hierarchies } from 'pif-preview'
import { InputChangedHandler } from './input'
import { PifListBox } from './PifListBox'
import { PifBmpTable } from './PifBmpTable'

export interface PifSelectorProps {
	pifItems: Array<FormItem>,
	coords: HierarchyCoords
	hierarchies: Hierarchies

	onFormTypeChanged: InputChangedHandler
	onApplicationTypeChanged: InputChangedHandler
	onIntakeChanged: InputChangedHandler
	onPifChanged: InputChangedHandler
}

export const PifSelector: React.FC<PifSelectorProps> = props => {
	const { onFormTypeChanged, onApplicationTypeChanged, onIntakeChanged, onPifChanged } = props
	const { coords, hierarchies } = props

	return (
		<>
			<Row className='mb-3'>
				<Col md={{ offset: 2, size: 8 }}>
					<DropDown
						label='Form Type: '
						options={getHierarchyOptions(hierarchies.formTypes!)}
						value={coords.formType}
						onChange={onFormTypeChanged}
						defaultText='-- SELECT --'
					/>
					<DropDown
						label='Application Type: '
						options={getHierarchyOptions(hierarchies.applicationTypes!)}
						value={coords.applicationTypeName}
						onChange={onApplicationTypeChanged}
						defaultText='-- SELECT --'
					/>
					<DropDown
						label='Intake: '
						options={getHierarchyOptions(hierarchies.intakes, coords.applicationTypeName)}
						value={coords.intakeKey}
						onChange={onIntakeChanged}
						defaultText='-- SELECT --'
					/>
				</Col>
			</Row>
			<Row className='mb-3'>
				<Col md={{ offset: 2, size: 8 }}>
					<PifListBox {...props} />
				</Col>
			</Row>
			<Row className='mb-3'>
				<Col md={{ offset: 2, size: 8 }}>
					<PifBmpTable {...props} />
				</Col>
			</Row>

		</>
	)
}

function getPifs(pifItems: Array<FormItem>, coords: HierarchyCoords): Array<FormItem> {
	if (coords.formType) {
		return pifItems
			.filter(pi =>
				getAssignments(pi, coords.formType!)
					.some(d => d.intakeKey == coords.intakeKey)
			)
	}
	else return [];
}

export function getPifOptions(pifItems: Array<FormItem>, coords: HierarchyCoords): Array<Option> {
	return getPifs(pifItems, coords)
		.map(pif => {
			return { text: pif.name, value: pif.formId }
		})
}
